export enum CareLineFields{
    Exame = 'exame',
    Categoria = 'categoria',
    SinalVital = 'sinalVital',
    Procedimento = 'procedimento'
}